import useCurrentPersonInfo from "./useCurrentPersonInfo";
import ListService from "../../Services/Shared/List.service";
/**
 * Returns whether the user has the given permission
 * null - permissions are loading, or there was an error loading permissions
 * true - current person has permission
 * false - current person does not have permission
 *
 * @returns {boolean} whether the user has the given permission
 */
const useHasPermission = (permission) => {
    const info = useCurrentPersonInfo();
    if (info.data == null) {
        return null;
    }
    return ListService.makeIntoList(permission).every((p) => { var _a, _b; return (_b = (_a = info.data) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.includes(p); });
};
export const HasPermission = ({ permission, children }) => useHasPermission(permission) ? children : null;
export default useHasPermission;
